import ACLStore from "lib/aclStore";
import { ENABLE_GOOGLE_DRIVE } from "Constants/permissionConstants";

export const enableGooglePhotosPicker = () => {
  return (
    ACLStore.can(ENABLE_GOOGLE_DRIVE) &&
    ACLStore.can("FeatureFlag:EnableGooglePhotosPicker")
  );
};
